import { colorUtils } from '@prisjakt/ui-base';
import React from 'react';
import styled, { AnyStyledComponent } from 'styled-components';

type Props = {
  children: string;
  component?: AnyStyledComponent;
};

/**
 * Accepts a string containing search highlight markup and returns a formatted React element.
 */
const HighlightedSearchResult = ({ children, component }: Props) => {
  const highlightPattern = /\[highlight\](.+?)\[\/highlight\]/g;
  const parts = [];
  let match = highlightPattern.exec(children);
  let nextPartStartIndex = 0;

  const Component = component || Highlight;

  while (match !== null) {
    // Yield a text node of the part from the start of the string or the end of the previous match
    // to the start of the current match
    parts.push(children.substring(nextPartStartIndex, match.index));

    // Yield the formatted content of the current match
    parts.push(<Component key={match.index}>{match[1]}</Component>);

    // Remember the end of the current match, and try to match the next highlight (if any)
    nextPartStartIndex = highlightPattern.lastIndex;
    match = highlightPattern.exec(children);
  }

  // Yield a text node of the part from the end of the last match to the end of the string
  parts.push(children.substr(nextPartStartIndex));

  return <>{parts}</>;
};

const Highlight = styled.em`
  background: ${({ theme }) =>
    colorUtils.setRgbaAlpha(theme.colors.yellove500, 0.2)};
  border-radius: 1px;
  box-shadow: 0 0 0 0.2em
    ${({ theme }) => colorUtils.setRgbaAlpha(theme.colors.yellove500, 0.2)};
  font-style: normal;
  font-weight: bold;
`;

export default HighlightedSearchResult;
